/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casemanagement_Slatab2Inputs */

const en_settings_casemanagement_slatab2 = /** @type {(inputs: Settings_Casemanagement_Slatab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA`)
};

/**
* | output |
* | --- |
* | "SLA" |
*
* @param {Settings_Casemanagement_Slatab2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casemanagement_slatab2 = /** @type {((inputs?: Settings_Casemanagement_Slatab2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casemanagement_Slatab2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casemanagement_slatab2(inputs)
});
export { settings_casemanagement_slatab2 as "settings_caseManagement_slaTab" }